// extracted by mini-css-extract-plugin
module.exports = {"carouselWrap":"VideoCarouselContainer_carouselWrap__oLHdR","title":"VideoCarouselContainer_title__2n9E9"};